import { gql } from "@apollo/client";

export const UpdateRfqTrnSupplyNego = gql`
  mutation UpdateRfqTrnSupplyNego(
    $token: String!
    $customerId: ID!
    $finYrId: ID!
    $user_details: SubscribedUser!
    $input: [UpdateNegoPrices!]!
  ) {
    UpdateRfqTrnSupplyNego(
      token: $token
      customerId: $customerId
      finYrId: $finYrId
      user_details: $user_details
      input: $input
    )
  }
`;
